<div fxLayout="column">
  <app-page-header [section]="'Details'"
                   [title]="'Setup your details to run smoothly'"
                   [description]="'The settings module allows you to view and configure your information. This configuration ' +
'automatically integrates across all other features like support and accounts.'">
  </app-page-header>

  <div class="page-padding page-content full-screen-height-page-default" fxLayout="column">

    <div class="full-width" fxLayout="row" fxLayoutGap="20px" fxFlexOffset="30px">
      <div class="info-card" fxLayout="column">
        <span class="heading-default">General information</span>
        <div fxLayout="row" fxLayoutGap="15px" fxFlexOffset="20px">
          <mat-form-field class="custom-text-autofill" appearance="outline">
            <mat-label>System ID</mat-label>
            <input matInput type="text" [value]="this.currentLocation?.uuid!.toString()" disabled />
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutGap="15px" fxFlexOffset="20px">
          <mat-form-field class="custom-text-autofill" appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput type="text" [value]="this.offering!.label" disabled/>
          </mat-form-field>
          <mat-form-field class="custom-text-autofill" appearance="outline" *ngIf="offering!.offeringAddress">
            <mat-label>Address</mat-label>
            <input matInput placeholder="Input offering address" type="text" [value]="this.offering!.offeringAddress"
                   disabled/>
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutGap="15px" fxFlexOffset="20px">
          <mat-form-field class="custom-text-autofill" appearance="outline">
            <mat-label>Property</mat-label>
            <input matInput type="text" [value]="this.currentLocation?.locationName" disabled/>
          </mat-form-field>
          <mat-form-field appearance="outline" class="custom-text-field">
            <mat-label>Property Address</mat-label>
            <input
              matInput
              matGoogleMapsAutocomplete
              [value]="this.currentLocation?.locationAddress!.formattedAddress"
              (onAutocompleteSelected)="onAddressAutocompleteSelected($event)"
              (onLocationSelected)="onAddressLocationSelected($event)" disabled />
          </mat-form-field>
        </div>

      </div>
    </div>

    <!--  External Account Software   -->
    <div class="full-width" fxFlexOffset="30px" fxLayout="row" fxLayoutGap="20px">
      <div class="info-card" fxLayout="column">
        <span class="heading-default">External accounting software</span>
        @for (setting of externalSettings; track setting.displayName) {
          <span class="subheading-default">{{ setting.displayName }}</span>
          @for (config of setting.configs; track config.chargeName) {
            <div fxLayout="row" fxLayoutGap="15px" fxFlexOffset="20px" fxLayoutAlign="start center">
              <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
                <mat-label>{{ config.chargeName }}</mat-label>
                <input matInput type="text" [(ngModel)]="config.chargeName" disabled/>
              </mat-form-field>
              <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
                <mat-label>Transaction Code</mat-label>
                <input matInput type="text" [(ngModel)]="config.transactionCode"
                       [disabled]="!!(loading$ | async)"/>
              </mat-form-field>
              <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
                <mat-label>Tax Type Code</mat-label>
                <input matInput placeholder="Input tax type code" type="text"
                       [(ngModel)]="config.taxTypeCode"
                       [disabled]="!!(loading$ | async)"/>
              </mat-form-field>
              <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
                <mat-label>Remarks</mat-label>
                <input matInput placeholder="Input remarks on statement" type="text"
                       [(ngModel)]="config.remarks"
                       [disabled]="!!(loading$ | async)"/>
              </mat-form-field>

              <button (click)="updateConfig(setting.code, config)" class="button-action"
                      [disabled]="!!(loading$ | async)"
                      mat-flat-button>
                <div class="button-text">Update</div>
              </button>
            </div>
          }
        }

      </div>
    </div>

  </div>
</div>
